import { API, graphqlOperation } from 'aws-amplify';
import { GraphQLResult } from '@aws-amplify/api-graphql';
import { listAITrainings } from '../../../../graphql/queries';

interface AITraining {
  id: string;
  orgID: string;
  service: string;
  name: string;
  description?: string;
  prompt: string;
  revision: number;
  status?: string;
  users?: string[];
  public?: boolean;
  createdBy?: string;
  lastUpdatedBy?: string;
  createdAt: string;
  updatedAt: string;
}

interface ListAITrainingsResponse {
  listAITrainings: {
    items: AITraining[];
  };
}

export default async function fetchAIPromptHistory(
  orgID: string,
  service: string
): Promise<AITraining[]> {
  try {
    const result = (await API.graphql(
      graphqlOperation(listAITrainings, {
        filter: {
          orgID: { eq: orgID },
          service: { eq: service },
        },
      })
    )) as GraphQLResult<ListAITrainingsResponse>;

    if (result.data) {
      // Sort by revision descending (newest first)
      return result.data.listAITrainings.items.sort(
        (a: AITraining, b: AITraining) => b.revision - a.revision
      );
    }
    return [];
  } catch (error) {
    console.error('Error fetching AI prompt history:', error);
    return [];
  }
}
